import { useState, useCallback } from 'react';
import { callApi } from '../utils/apiClient';
import { API_ENDPOINTS } from '../config/api/apiCall';


export const useTransporter = (commonParams) => {
  const [dataTransporter, setDataTransporter] = useState([]);
  const [selectedTransporter, setSelectedTransporter] = useState(null);
  const [transporterCode, setTransporterCode] = useState(null);

  const loadTransporter = useCallback(async () => {
    const para = {
      ...commonParams,
      masterGroup: 'SO_TRANSPORTER',
    };

    try {
      const result = await callApi(
        API_ENDPOINTS.GET_MASTER_LIST,
        'POST',
        { 'Content-Type': 'application/json' },
        para
      );

      if (result && result.length > 0) {
        const updatedData =
          Array.isArray(result) && !result.includes('')
            ? [''].concat(result)
            : result;

        setDataTransporter(updatedData);

        // Set default if only one transporter exists
        if (updatedData.length <= 2 && updatedData.length > 0) {
          setSelectedTransporter(updatedData[1]);
          setTransporterCode(updatedData[1].CodeId);
        }
      } else {
        alert('Transporter details not found');
      }
    } catch (error) {
      alert(error.message);
    }
  }, [commonParams]);

  return {
    dataTransporter,
    selectedTransporter,
    transporterCode,
    setSelectedTransporter,
    loadTransporter,
  };
};
